import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractService } from './abstract.service';
import { LoginService } from './login.service';
import { DatabaseExclusao, ExclusaoConsulta } from '../models/database-exclusao';
import { Observable } from 'rxjs';
import { DateUtils } from '../utilities/util/date-utils';

@Injectable({
  providedIn: 'root'
})
export class DatabaseExclusaoService extends AbstractService<DatabaseExclusao> {

  titulo: string = 'Exclusão de bancos de dados';
  endpoint(): string {
    return "admin/db-exclusao";
  }
  rotina(): string {
    return "POLITICA_EXCLUSAO";
  }
  colunas(): any[] {
    return [
      { header: "Código", field: "id" },
      { header: "Nome", field: "nome" },
    ];
  }

  novo(selection?: any) {
    AbstractService.readonly = false;
    this.router.navigate(['adm/politica-exclusao']);
  }

  abrir(obj: DatabaseExclusao) {
    AbstractService.readonly = true;
    this.router.navigate(['adm/politica-exclusao'], { queryParams: { id: obj.id } });
  }

  edit(obj: DatabaseExclusao) {
    AbstractService.readonly = false;
    this.router.navigate(['adm/politica-exclusao'], { queryParams: { id: obj.id } });
  }

  routeLista() {
    return '/adm/politica-exclusao';
  }

  fazConsulta(dataInicial: Date, dataFinal: Date, excluidos: boolean): Observable<ExclusaoConsulta[]> {
    const di = DateUtils.dateTimeToString(DateUtils.startOfTheDay(dataInicial));
    const df = DateUtils.dateTimeToString(DateUtils.endOfTheDay(dataFinal));
    const url = this.baseUrl() +
      `/consulta?excluidos=${excluidos ? 'true' : 'false'}&data-inicial=${di}&data-final=${df}`;

    const h = new HttpHeaders({
      Accept: "application/json; charset=utf-8",
      "X-Auth-Token": AbstractService.token(),
    });
    return this.http.get<ExclusaoConsulta[]>(url, { headers: h });
  }

  excluiDb(id: number, name: string): Observable<HttpResponse<any>> {
    const url = this.baseUrl() + "/exclui";
    const params = new URLSearchParams();
    params.append("id", id.toString());
    params.append("name", name);

    const h = new HttpHeaders({
      Accept: "application/json; charset=utf-8",
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Auth-Token": AbstractService.token(),
    });
    return this.http.post<any>(url, params.toString(), { headers: h, observe: 'response' });
  }

  constructor(
    http: HttpClient,
    private router: Router,
    loginService: LoginService
  ) {
    super(http, loginService);
  }
}
